export default "__VITE_ASSET__4ner_jZy__"